module.exports = __webpack_public_path__ + "img/logo-copy.4ad72430.jpg";